import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from '../SvgIcon';
import { getColor } from '../utils';

export const LogOut = ({
  height = 24,
  width = 24,
  color = colors.grey90,
  isColorInherited = true,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    data-temporary-fix
    data-test="log-out-icon"
    height={height}
    width={width}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M7.79114 11.9156C7.79114 11.346 8.25283 10.8843 8.82239 10.8843C9.39195 10.8843 9.85364 11.346 9.85364 11.9156C9.85364 12.4851 9.39195 12.9468 8.82239 12.9468C8.25283 12.9468 7.79114 12.4851 7.79114 11.9156Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.90853 2.49567L4.04447 4.17104C3.14293 4.42861 2.52136 5.25263 2.52136 6.19025V18.293C2.52136 19.2597 3.19664 20.095 4.14185 20.2975L9.92122 21.5359C11.2596 21.8227 12.5217 20.8024 12.5217 19.4336V4.46681C12.5217 3.10484 11.2181 2.12153 9.90853 2.49567ZM4.02136 6.19025C4.02136 5.92236 4.19895 5.68693 4.45654 5.61333L10.3206 3.93797C10.6719 3.83758 11.0217 4.1014 11.0217 4.46681V19.4336C11.0217 19.8474 10.6401 20.1559 10.2355 20.0692L4.45613 18.8308C4.20254 18.7765 4.02136 18.5524 4.02136 18.293V6.19025Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M13.2286 5.16556C13.2286 4.75134 13.5644 4.41556 13.9786 4.41556H17.3536C17.8509 4.41556 18.3278 4.61309 18.6795 4.96473C19.0312 5.3164 19.2286 5.79333 19.2286 6.29056V7.41556C19.2286 7.82977 18.8929 8.16556 18.4786 8.16556C18.0644 8.16556 17.7286 7.82977 17.7286 7.41556V6.29056C17.7286 6.19106 17.6891 6.09568 17.6188 6.02539C17.5485 5.95509 17.4531 5.91556 17.3536 5.91556H13.9786C13.5644 5.91556 13.2286 5.57977 13.2286 5.16556Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M19.2286 16.4156V17.5406C19.2286 18.0377 19.0312 18.5147 18.6795 18.8664C18.3278 19.2181 17.8508 19.4156 17.3536 19.4156H13.9786C13.5644 19.4156 13.2286 19.0798 13.2286 18.6656C13.2286 18.2513 13.5644 17.9156 13.9786 17.9156H17.3536C17.4532 17.9156 17.5486 17.876 17.6188 17.8058C17.6891 17.7355 17.7286 17.6401 17.7286 17.5406V16.4156C17.7286 16.0013 18.0644 15.6656 18.4786 15.6656C18.8929 15.6656 19.2286 16.0013 19.2286 16.4156Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M17.9483 10.1959C17.6554 9.90299 17.6554 9.42812 17.9483 9.13523C18.2412 8.84233 18.7161 8.84233 19.009 9.13523L21.259 11.3852C21.3925 11.5188 21.4652 11.6902 21.4769 11.8649C21.4802 11.9137 21.4788 11.963 21.4724 12.012C21.4542 12.1535 21.3956 12.2909 21.2966 12.4054C21.2833 12.4208 21.2695 12.4356 21.255 12.4498L19.009 14.6959C18.7161 14.9888 18.2412 14.9888 17.9483 14.6959C17.6554 14.403 17.6554 13.9281 17.9483 13.6352L18.918 12.6656H14.5411C14.1269 12.6656 13.7911 12.3298 13.7911 11.9156C13.7911 11.5013 14.1269 11.1656 14.5411 11.1656H18.918L17.9483 10.1959Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
